import { render, staticRenderFns } from "./BasicReq.vue?vue&type=template&id=c90f740a&scoped=true&"
import script from "./BasicReq.vue?vue&type=script&lang=js&"
export * from "./BasicReq.vue?vue&type=script&lang=js&"
import style0 from "./BasicReq.vue?vue&type=style&index=0&id=c90f740a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90f740a",
  null
  
)

export default component.exports